__turbopack_context__.v({
  "default": "AgencyTag-module__ygMpfG__default",
  "reversed": "AgencyTag-module__ygMpfG__reversed",
  "tag": "AgencyTag-module__ygMpfG__tag",
});
